import { render, staticRenderFns } from "./FilamentFileList.vue?vue&type=template&id=01a165e9"
import script from "./FilamentFileList.vue?vue&type=script&lang=ts"
export * from "./FilamentFileList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports